module.exports = __webpack_public_path__ + "img/gylxt-w.80bf825d.svg";